/* Auto-generated from photo-zone-template.ejs */
const template = function anonymous(data, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div id=\"template-zone-<%- data.zoneIndex %>\" data-free-object-id=\"<%- data.freeObjectId %>\" data-type=\"photo\"\n     class=\"template-zone photo-zone<%- (data.hasPhoto ? ' has-photo' : '') %>\">\n    <div class=\"columns\">\n        <div class=\"column\">\n            <div class=\"field\">\n                <div class=\"file is-info has-name is-fullwidth\">\n                    <label for=\"zone-file-input-<%- data.freeObjectId %>\" class=\"file-label\">\n                        <input id=\"zone-file-input-<%- data.freeObjectId %>\" data-free-object-id=\"<%- data.freeObjectId %>\"\n                               class=\"file-input\" type=\"file\" accept=\"image/jpeg,image/png,image/webp\">\n                        <span class=\"upload-icon icon\"></span>\n                        <span class=\"upload-label\"><%-data. tr('DROP_IMAGE_HERE_OR_BROWSE', 'Drop your image here, or browse') %></span>\n                        <span class=\"upload-label-mobile\"><%- data.tr('CLICK_HERE_UPLOAD', 'Click here to upload your image') %></span>\n                        <span id=\"zone-file-name-<%- data.freeObjectId %>\" class=\"zone-file-name\"><%- data.fileName %></span>\n                        <span class=\"zone-file-icon\">\n                            <i class=\"fas fa-check\"></i>\n                        </span>\n                    </label>\n                </div>\n\n                <div class=\"zoom-panel\">\n                    <span class=\"zoom-instructions\">\n                    <% if (data.isTouchOnly) { %>\n                        <%- data.tr('ZOOM_IN_INSTRUCTIONS_TOUCH', 'Use the buttons below, or pinch to zoom in and out') %>\n                    <% } else { %>\n                        <%- data.tr('ZOOM_IN_INSTRUCTIONS_DESKTOP', 'Use the buttons below, or the mouse wheel to zoom in and out') %>\n                    <% } %>\n                    </span>\n                    <div id=\"zoom-button-container\">\n                        <button aria-label=\"Zoom In\" class=\"button button-zoom-in is-medium\" disabled>\n                            <span class=\"zoom-in-icon icon\"></span>\n                            <span class=\"zoom-in-out-text\"><%- data.tr('ZOOM_IN_BUTTON', 'Zoom In') %></span>\n                        </button>\n\n                        <button aria-label=\"Zoom Out\" class=\"button button-zoom-out is-medium\" disabled>\n                            <span class=\"zoom-out-icon icon\"></span>\n                            <span class=\"zoom-in-out-text\"><%- data.tr('ZOOM_OUT_BUTTON', 'Zoom Out') %></span>\n                        </button>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>\n\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
    ; __append("<div id=\"template-zone-")
    ; __append( data.zoneIndex )
    ; __append("\" data-free-object-id=\"")
    ; __append( data.freeObjectId )
    ; __append("\" data-type=\"photo\"\n     class=\"template-zone photo-zone")
    ; __line = 2
    ; __append( (data.hasPhoto ? ' has-photo' : '') )
    ; __append("\">\n    <div class=\"columns\">\n        <div class=\"column\">\n            <div class=\"field\">\n                <div class=\"file is-info has-name is-fullwidth\">\n                    <label for=\"zone-file-input-")
    ; __line = 7
    ; __append( data.freeObjectId )
    ; __append("\" class=\"file-label\">\n                        <input id=\"zone-file-input-")
    ; __line = 8
    ; __append( data.freeObjectId )
    ; __append("\" data-free-object-id=\"")
    ; __append( data.freeObjectId )
    ; __append("\"\n                               class=\"file-input\" type=\"file\" accept=\"image/jpeg,image/png,image/webp\">\n                        <span class=\"upload-icon icon\"></span>\n                        <span class=\"upload-label\">")
    ; __line = 11
    ; __append(data. tr('DROP_IMAGE_HERE_OR_BROWSE', 'Drop your image here, or browse') )
    ; __append("</span>\n                        <span class=\"upload-label-mobile\">")
    ; __line = 12
    ; __append( data.tr('CLICK_HERE_UPLOAD', 'Click here to upload your image') )
    ; __append("</span>\n                        <span id=\"zone-file-name-")
    ; __line = 13
    ; __append( data.freeObjectId )
    ; __append("\" class=\"zone-file-name\">")
    ; __append( data.fileName )
    ; __append("</span>\n                        <span class=\"zone-file-icon\">\n                            <i class=\"fas fa-check\"></i>\n                        </span>\n                    </label>\n                </div>\n\n                <div class=\"zoom-panel\">\n                    <span class=\"zoom-instructions\">\n                    ")
    ; __line = 22
    ;  if (data.isTouchOnly) { 
    ; __append("\n                        ")
    ; __line = 23
    ; __append( data.tr('ZOOM_IN_INSTRUCTIONS_TOUCH', 'Use the buttons below, or pinch to zoom in and out') )
    ; __append("\n                    ")
    ; __line = 24
    ;  } else { 
    ; __append("\n                        ")
    ; __line = 25
    ; __append( data.tr('ZOOM_IN_INSTRUCTIONS_DESKTOP', 'Use the buttons below, or the mouse wheel to zoom in and out') )
    ; __append("\n                    ")
    ; __line = 26
    ;  } 
    ; __append("\n                    </span>\n                    <div id=\"zoom-button-container\">\n                        <button aria-label=\"Zoom In\" class=\"button button-zoom-in is-medium\" disabled>\n                            <span class=\"zoom-in-icon icon\"></span>\n                            <span class=\"zoom-in-out-text\">")
    ; __line = 31
    ; __append( data.tr('ZOOM_IN_BUTTON', 'Zoom In') )
    ; __append("</span>\n                        </button>\n\n                        <button aria-label=\"Zoom Out\" class=\"button button-zoom-out is-medium\" disabled>\n                            <span class=\"zoom-out-icon icon\"></span>\n                            <span class=\"zoom-in-out-text\">")
    ; __line = 36
    ; __append( data.tr('ZOOM_OUT_BUTTON', 'Zoom Out') )
    ; __append("</span>\n                        </button>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>\n\n")
    ; __line = 46
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

};
export default template;
